function sintomas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os sintomas mais comuns são: tosse, dor de garganta, febre, coriza, dificuldade para respirar ou falta de ar, perda de olfato, alteração do paladar.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Os sintomas costumam surgir em  5-6  dias, mas esse tempo pode variar.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Os sintomas mais raros e leves relatados pelos doentes incluem dores de cabeça, erupção cutânea, conjuntivite e descoloração da pele dos dedos das mãos ou dos pés.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Cerca de 80% dos doentes permanecem assintomáticos ou possuem poucos sintomas, recuperando-se sem a necessidade de tratamento hospitalar.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Aproximadamente uma em cada cinco pessoas infectadas desenvolvem quadros mais graves da doença.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Idosos, gestantes, crianças com menos de 5 anos, pacientes com comorbidades e fumantes correm maiores riscos ao contrair a doença (grupo de risco), podendo chegar a óbito.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/sintomas/1.png"
			}
		]
	};
}

export {sintomas};
